/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var scrollTop;
var bannerHeight;
var propVideo;
var propHeader;
var altoHero;

function amountscrolled(){
  var winheight = jQuery(window).height()
  var docheight = jQuery(document).height()
  var scrollTop = jQuery(window).scrollTop()
  var trackLength = docheight - winheight
  var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
 // console.log(pctScrolled + '% scrolled')
  return pctScrolled;
}

/*
function getScrollPercent() {
    var h = document.documentElement, 
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
    return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}
*/


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        if(jQuery('.wp-pagenavi').length>0){

            jQuery('.wp-pagenavi .page, .wp-pagenavi  .current,  .wp-pagenavi  .extend, .wp-pagenavi  .nextpostslink, .wp-pagenavi  .previouspostslink').each(function(i){

              jQuery(this).width(jQuery(this).height() ) ;
        
            }); 
        }
        //icon-search

 
 
        resize();

        


        jQuery('.liSub > a').on('click', function(ev){
          ev.preventDefault();
        });

 
          jQuery('.open_baix').on('click', function(ev){
            ev.preventDefault();
            jQuery('.cont_ventaja').slideUp();

            
            if(jQuery(ev.currentTarget).hasClass('abierto')){
              jQuery(ev.currentTarget).stop().slideUp();
              jQuery('.open_baix').removeClass('abierto');
            }else{
              jQuery(ev.currentTarget).addClass('abierto');
              jQuery(ev.currentTarget).stop().next().slideDown();
            }
            
          })


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'page_template_template_sobre_mi_children':{
      init:function(){
      //Swipper medios

            var mySwiperMedios = new Swiper('#swiper_medios', {
              speed: 450,
              spaceBetween: 10,
              slidesPerView:2,
              loop: true  ,
              disableOnInteraction:false,
              autoplay: {
                delay: 5000,
              },

              breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                // when window width is >= 480px
                768: {
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                // when window width is >= 640px
                960: {
                  slidesPerView: 6,
                  spaceBetween: 40
                }
              }


          });
      }
    },
    // Home page
    'page_template_template_home_children': {
      init: function() {
        // JavaScript to be fired on the home page
 
          /*  $('#bot_next_proy').on('click', function(ev){
              ev.preventDefault();  
              $.scrollify.next();
    
            });*/
 
          //$.scrollify.next()

          // SWIPER

          var mySwiperTitTesti = new Swiper('#swiper_testi_1', {
            speed: 450,
            spaceBetween: 100,
            loop: true ,
            thumbs: {
              swiper: mySwiperContTesti,
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var mySwiperContTesti= new Swiper('#swiper_testi_2', {
          speed: 400,
          spaceBetween: 150,
          loop: true, 
          navigation: {
            nextEl: '#swiper_testi_2 .fl_der',
            prevEl: '#swiper_testi_2 .fl_izq',
          },
          thumbs: {
            swiper: mySwiperTitTesti,
          },
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          autoplay: {
              delay: 5500, 
           },

      });


      //Swipper medios

      var mySwiperMedios = new Swiper('#swiper_medios', {
        speed: 450,
        spaceBetween: 10,
        slidesPerView:2,
        loop: true  ,
        disableOnInteraction:false,
        autoplay: {
          delay: 5000,
        },

        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 480px
          768: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          // when window width is >= 640px
          960: {
            slidesPerView: 6,
            spaceBetween: 40
          }
        }


    });

/*

          autoplay: {
           // delay: 2500, 
          },
*/
        



      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'single_product': {
      init: function() {
        // JavaScript to be fired on the about us page

            


      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

window.onload=function(){


  resize();
  

 /*
  jQuery('html').scrollWithEase({
    frameRate: 60,
    animationTime: 500,
    stepSize: 20,
    pulseAlgorithm: true,
    pulseScale: 8,
    pulseNormalize: 1,
    accelerationDelta: 700,
    accelerationMax: 5,
    keyboardSupport: true,
    arrowScroll: 50   
  });

*/
  jQuery('.bot_movil').on('click', function(ev){
    ev.preventDefault();
    jQuery(this).toggleClass('abierto'); 
    //jQuery('.nav-primary').slideToggle('normal'); 
    jQuery('.nav-primary').toggleClass('menu_cerrado');
    jQuery('.banner').toggleClass('desplegado');

  });


  jQuery('.item_sub_submenu').on('click', function(){
    //alert("!!!!" + jQuery(this).attr('href'));
    var link = jQuery(this).attr('href');
    window.location.href = jQuery(this).attr('href');
  });

      jQuery('.menu_prin > li.liChildren').on('click', function(ev){ 
        ev.preventDefault();
      })
     
      jQuery('.tinc_sub').on('click', function(ev){ 

 
        
        ev.preventDefault();
        /*  
        jQuery(this).next().slideToggle('normal', function(){
          
        });
        */

        if(jQuery(this).hasClass('open_menu')){
          jQuery(this).next().slideUp('normal', function(){
            jQuery('.tinc_sub').removeClass('open_menu');
          });
        }else{
           
          jQuery(this).next().slideDown('normal', function(){

            jQuery('.tinc_sub').addClass('open_menu');
          });
        }

      });
  

        jQuery('.liSub > a').on('click', function(ev){
          ev.preventDefault();
        });
  if(jQuery(window).width() < 1024 ){
 




  }

 

if(jQuery(window).width()>992){

    jQuery('#bot_busca_header').on('click', function(ev){
      ev.preventDefault();
      //jQuery('.out_buscador').slideToggle(400); 
      jQuery('.buscador_up').toggleClass('sacaBusca');
 
      jQuery('.page-template-template-home .banner').toggleClass('fon_blanco_banner');
  });

}


 

if(jQuery(window).width() < 768 ){
 

}

/*
m=(T1-T0)/(D1-D0)
n=T0-D0*m 

  var winheight = jQuery(window).height()
  var docheight = jQuery(document).height() 
  var trackLength = docheight - winheight

*/

var winheight = jQuery(window).height();
var docheight = jQuery(document).height() ;
var trackLength = docheight - winheight;

jQuery('.parallax_vert').each(function(){

  //console.log(jQuery(this).data('inipos'));
 // console.log(jQuery(this).data('finpos'));
  var iPos = jQuery(this).data('inipos');
  var fPos = jQuery(this).data('finpos');
  var eme = (fPos-iPos)/(100);
  var ene = iPos ;
  jQuery(this).data('m', eme );
  jQuery(this).data('n',  ene) ;

});

/*
T0=D0*m +n
T1=D1*m +n

m=(T1-T0)/(D1-D0)
n=T0-D0*m
*/

jQuery('.parallax_per').each(function(){

  //console.log(jQuery(this).data('inipos'));
  //console.log(jQuery(this).data('finpos'));
  var iPos = jQuery(this).data('iniposy');
  var fPos = jQuery(this).data('finposy');


  var iniPerY = jQuery(this).css('transform').split(','); //jQuery(this).data('inipery');

  iniPerY = parseFloat(iniPerY[5]);

  console.log(" IPOS " + iPos +" FPOS "+fPos);

  var eme = (fPos-iPos)/(100);
  var ene = iPos; 

  console.log(" eme " + eme +" ene " + ene);

  jQuery(this).data('m', eme );
  jQuery(this).data('n',  ene) ;
  jQuery(this).data('inipery',  iniPerY) ;

});
 
 
//FORMULARIO

jQuery('input[type="text"], input[type="email"] , textarea').each(function(){
 
  jQuery(this).data('valor', jQuery(this).val() );
  console.log(jQuery(this).data('valor' ) );
});


jQuery('input[type="text"], input[type="email"] , textarea').on('focus', function(ev){

 console.log(jQuery(this).data('valor'));
 if(jQuery(this).val() == jQuery(this).data('valor') ) {
   jQuery(this).val("");
 }


})

jQuery('input[type="text"], input[type="email"] , textarea').on('focusout', function(ev){

  console.log(jQuery(this).data('valor'));
  if(jQuery(this).val() == "" ) {
    jQuery(this).val(jQuery(this).data('valor'));
  }
 
 
 })

 jQuery('html').scrollWithEase({
  frameRate: 120,
  animationTime: 1000,
  stepSize: 20,
  pulseAlgorithm: true,
  pulseScale: 8,
  pulseNormalize: 1,
  accelerationDelta: 700,
  accelerationMax: 5,
  keyboardSupport: true,
  arrowScroll: 50   
});

//bot_informate

/*

*/


jQuery('.bot_go').on('click', function(ev){
 
  var posGo = jQuery(ev.currentTarget).attr('href'); 

  posGo = jQuery(posGo).offset();
  posGo = posGo.top;
  var openFormu= false;
  
  if(jQuery(this).hasClass('bot_informate') ){
   
    openFormu = true;
  }
    
    jQuery("html, body").animate( 
        { scrollTop: posGo }, 700, function(){ 
            if(openFormu){
              jQuery('#formu_info').slideDown(700);
            }
        }); 
 


});


if( jQuery('#formu_life_coaching')){
  jQuery('#formu_life_coaching').slideUp(0);
}


if(jQuery('#boton_activa_capacidad')){

  jQuery('#boton_activa_capacidad').on('click', function(ev){
    ev.preventDefault();

    jQuery('#formu_life_coaching').slideToggle();

  })

}


} //onLoad


function resize(){

  if(jQuery('.in_caja')){
    var resto = (jQuery(window).width() - jQuery('.container').outerWidth())/2 ; 
    jQuery('.in_caja').width( jQuery('.in_caja').parent().outerWidth() + resto +15  )
  }


  bannerHeight = jQuery('.banner').outerHeight(true) ;

  if(jQuery('.cont_video')){
  
      propVideo = jQuery('.cont_video iframe').attr('width')/jQuery('.cont_video iframe').attr('height');
 
    jQuery('.cont_video iframe').height( jQuery('.cont_video iframe').width() / propVideo ) ;

      

  }
var bh  = jQuery('.banner').outerHeight(true)  ;
console.log("BANNER HEIGHT "+ bh );

  jQuery('.sep_menu').height( bh  );


  jQuery('.baix_text').width(jQuery('.caja_dire').outerWidth() );
  jQuery('.baix_text').height(jQuery('.caja_dire').outerHeight() );

  jQuery('.img_marg_up').each(function(i){
    jQuery(this).css('margin-top', jQuery(this).height()/2 * -1 );
  });


  jQuery('.pad_50_img').css('padding-bottom', (jQuery('.img_marg_up').outerHeight()/2  )+"px" );
 
  if(jQuery(document).width() > 1024){
      if(jQuery('.caja_sobre_foto').outerHeight()>=jQuery('.cont_img_collect').outerHeight() ){
        //jQuery('.cont_img_collect').height(jQuery('.caja_sobre_foto').outerHeight() + 100 );
        jQuery('.cont_img_collect').css('min-height', jQuery('.caja_sobre_foto').outerHeight() + 100 );
      }

  }

  jQuery('.prod_image').height(jQuery('.prod_texto').outerHeight());
 

  if(jQuery('.caja_sobre_foto').outerHeight() > jQuery('.cont_img_collect ').outerHeight() ){
 

    jQuery('.cont_img_collect').height(jQuery('.caja_sobre_foto').outerHeight() + 100 ) ;

  }
 
if(jQuery(window).width()< 480){

 

}

/*
jQuery('.logo_brand svg').css({
  'width': jQuery('.logo_brand').width() + 'px',
    'height': jQuery('.logo_brand').height() + 'px'
  
})
*/

if(jQuery(window).width() > 768 ){

  jQuery('.p_desta').css('min-height', jQuery('.p_desta').outerWidth() );

}



var pleft = jQuery('.p_desta').offset() ;
pleft+=jQuery('.p_desta').width();

jQuery('.circulos').css('left', pleft.left ) ;



//header

propHeader = jQuery('#img_header').data('prop');

if(propHeader){ 

  if(jQuery(window).width()>768){
        jQuery('#fon_image').height( jQuery('#cont_img_header').width()/propHeader ); 
        jQuery('.sombra').height( jQuery('#fon_image').height()  );
        jQuery('.sombra').width( jQuery('#cont_img_header').width()  );

  }


}


jQuery('.img_in_vuela').height(jQuery('.img_vuela').height() + 100 );


jQuery('.bajo_pega').height(jQuery('.img_vuela').height() );



jQuery('.haz_cir').each(function(){

  jQuery(this).height(jQuery(this).width() );

});


jQuery('.forzar_cuadrado').each(function(){

  jQuery(this).css('min-height', jQuery(this).width() );

});


var altaTop = jQuery('.cont_video').outerHeight() - jQuery('.cont_video iframe').height();

//alert(jQuery('.cont_video').outerHeight() +" / "+  jQuery('.cont_video iframe').height());

jQuery('.bloque_posts').css('margin-top', (altaTop*-1 +70) );

jQuery('.sombraVideo').width(jQuery('.cont_video iframe').width());
jQuery('.sombraVideo').height(jQuery('.cont_video iframe').innerHeight() );


} //resize





jQuery(window).on('resize' , function(){

  resize(); 

});

//SCROLL
// .circulos


function amountscrolled(){
  var winheight = jQuery(window).height()
  var docheight = jQuery(document).height()
  var scrollTop = jQuery(window).scrollTop()
  var trackLength = docheight - winheight
  var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
 // console.log(pctScrolled + '% scrolled')
  return pctScrolled;
}

function amountscrolled2(){
  var winheight = jQuery(window).height()
  var docheight = jQuery(document).height()
  var scrollTop = jQuery(window).scrollTop()
  var trackLength = docheight - winheight
  var pctScrolled =  (scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
  pctScrolled = pctScrolled.toFixed(2);
 // console.log(pctScrolled + '% scrolled')
  return pctScrolled;
}

jQuery(window).on('scroll', function(ev){
 

 
    scrollTop = jQuery(window).scrollTop();

    var perScrolled = amountscrolled2();

    //this.console.log(perScrolled);

    jQuery('.parallax_vert').each(function(){

      /*
      console.log(jQuery(this).data('inipos'));
      console.log(jQuery(this).data('finpos'));
      var iPos = jQuery(this).data('inipos');
      var fPos = jQuery(this).data('finpos');
      var eme = (fPos-iPos)/(trackLength);
      var ene = iPos ;
      jQuery(this).data('m', eme );
      jQuery(this).data('n',  ene) ;
      */

      var tmpM = jQuery(this).data('m');
      var tmpN = jQuery(this).data('n');

      jQuery(this).css('bottom', (perScrolled*tmpM + tmpN) );
    
    });
     
    jQuery('.parallax_per').each(function(){

      

        var tmpM = jQuery(this).data('m');
        var tmpN = jQuery(this).data('n');
        var iniPerY = jQuery(this).data('inipery');

        console.log("M "+tmpM+" N "+ tmpN + " INIPERY " + iniPerY );

        var trans =jQuery(this).css('transform').split(',') ;

        var perX = trans[4];
        perX = parseFloat(perX);

        var perY =  trans[5];
        perY = parseFloat(perY);
        perY = iniPerY - (perScrolled*tmpM + tmpN) ; //perY*tmpM + tmpN;
        
        console.log("perY");
        console.log(perY);

        console.log("perX");
        console.log(perX);

      

        //(perScrolled*tmpM + tmpN)//      
        //jQuery(this).css('transform', 'translate(' + perX +','+perY +' )'  );
        jQuery(this).css('transform', 'translate(' + perX +'px ,'+perY  +'px )'  );
    
    });
     

   


    if(scrollTop > bannerHeight){

    //  $('.banner').addClass('minibar');

      jQuery('.banner').addClass('minibar_nu');
      jQuery('.logo_sb').addClass('logo_affected');

    }else{

    //  $('.banner').removeClass('minibar');

      jQuery('.banner').removeClass('minibar_nu');
      jQuery('.logo_sb').removeClass('logo_affected');

    }
 



});